import { useProducts } from "@/hooks/useProducts";
import ProductCard from "./ProductCard";
import { Link } from "react-router-dom";
import { ArrowRight, Flame } from "lucide-react";
import ScrollReveal from "@/components/3d/ScrollReveal";

const FeaturedProducts = () => {
  const { data: products = [], isLoading } = useProducts();
  const featured = products.slice(0, 8);

  return (
    <section className="relative py-10">
      <div className="container mx-auto px-4">
        <ScrollReveal direction="up">
          <div className="flex items-end justify-between mb-6">
            <div className="flex items-center gap-3">
              <Flame className="h-5 w-5 text-primary" />
              <h2 className="font-display text-2xl font-black">New Drops</h2>
            </div>
            <Link to="/shop" className="hidden items-center gap-1 text-xs font-medium text-muted-foreground transition-colors hover:text-primary sm:flex">
              View All <ArrowRight className="h-3 w-3" />
            </Link>
          </div>
        </ScrollReveal>
        <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
          {isLoading
            ? Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="animate-pulse rounded-lg border border-border/50 bg-card">
                  <div className="aspect-square bg-secondary" />
                  <div className="p-3 space-y-2">
                    <div className="h-3 w-2/3 rounded bg-secondary" />
                    <div className="h-3 w-1/3 rounded bg-secondary" />
                  </div>
                </div>
              ))
            : featured.map((p, i) => (
                <ScrollReveal key={p.id} direction="up" delay={i * 0.05}>
                  <ProductCard product={p} index={0} />
                </ScrollReveal>
              ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
